import React from "react";
import "../../../AllComponentCSS.css";

function JS_map() {
  return (
    <div className="tutorial-page">
      <h1>JS map</h1>
      <p>This page will cover the map topic in detail.</p>
    </div>
  );
}

export default JS_map;
